import React, { useEffect, useState } from "react";
import CustomButton from "../CustomButton";
import DesignCard from "../DesignCard";
import {
  Col,
  FormGroup,
  Label,
  Row,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Modal,
} from "reactstrap";
import Icon from "react-icons-kit";
import config from "../../utils/config";
import get from "lodash/get";
import { ic_check } from "react-icons-kit/md/ic_check";
import { ic_close } from "react-icons-kit/md/ic_close";
import { useDispatch, useSelector } from "react-redux";
import {
  approveRejectUpdatedPartnerDetails,
  deleteUpdatedPartnerDetails,
  fetchUpdatedPartnersData,
} from "../../redux/partners/actions";
import InputText from "../InputText";

const _ = { get };

const UpdateModal = (props) => {
  const { usertype } = useSelector((state) => state.Auth);
  const dispatch = useDispatch();
  const [activeCollapse, setActiveCollapse] = useState(false);
  const { elements } = useSelector((state) => state.Elements);
  const ToggleCollapse = () => {
    setActiveCollapse(!activeCollapse);
  };
  const [key, setKey] = useState("");
  const [rejectionReason, setRejectionReason] = useState("");
  const [indexId, setIndexId] = useState("");
  const [rejectionReasonImage, setRejectionReasonImage] = useState("");
  const [rejectionReasonToggle, setRejectionReasonToggle] = useState(false);

  const { fetchingUpdatedDetails, updatedDetails } = useSelector(
    (state) => state.Partner
  );

  const handleReject = () => {
    setRejectionReasonToggle(!rejectionReasonToggle);
    handleAcceptorRejectImage("REJECTED");
  };

  const rejectionOnSubmit = () => {
    let data = {
      partnerId: props.partnerId,
      status: "REJECTED",
      rejectionReason: rejectionReason,
      key: key,
    };
    dispatch(approveRejectUpdatedPartnerDetails(data, ToggleCollapse));
  };

  const approveOnClick = (keys) => {
    let data = {
      partnerId: props.partnerId,
      status: "APPROVED",
      key: keys,
    };
    dispatch(approveRejectUpdatedPartnerDetails(data));
  };

  const handleAcceptorRejectImage = (status) => {
    let data = {
      partnerId: props.partnerId,
      status: status,
      key: "gallery",
      rejectionReason: rejectionReasonImage !== "" ? rejectionReasonImage : "",
    };
    dispatch(approveRejectUpdatedPartnerDetails(data));
  };

  const handleDeleteField = (keys) => {
    let data = {
      partnerId: props.partnerId,
      key: keys,
    };
    dispatch(deleteUpdatedPartnerDetails(data));
  };

  const FieldName = [
    {
      name: "name",
      value: "Business Name",
    },
    {
      name: "bio",
      value: "Short Bio (Profile) of your Business",
    },
    {
      name: "location",
      value: "Current Location",
    },
    {
      name: "email",
      value: "Email",
    },
    {
      name: "geo",
      value: "Current Location Longitutde and Latitude",
    },
    {
      name: "mobile",
      value: "Contact Number",
    },
    {
      name: "secondaryNumber",
      value: "Alternative Contact Number",
    },
    {
      name: "social",
      value: "Website & Instagram",
    },
    {
      name: "rating",
      value: "Partner Rating",
    },
    {
      name: "thumbnailImage",
      value: "Landing Page Filter Thumbnail (160 x 190 px)",
    },
    {
      name: "thumbnailListingDesktop",
      value: "Partner Listing Page Thumbnail - Desktop (450 x 380 px)",
    },
    {
      name: "thumbnailListingMobile",
      value: "Partner Listing Page Thumbnail - Mobile (400 x 200 px)",
    },
    {
      name: "thumbnailDetailDesktop",
      value: "Partner Detail Page - Top Banner - Desktop - (1920 x 620 px)",
    },
    {
      name: "thumbnailDetailMobile",
      value: "Partner Detail Page - Top Banner - Mobile - (450 x 800 px)",
    },
    {
      name: "thumbnailDetailBannerDesktop",
      value: "Partner Detail Page- Bottom Banner - Desktop - (1920 x 600 px)",
    },
    {
      name: "thumbnailDetailBannerMobile",
      value: "Partner Detail Page- Bottom Banner - Mobile - (450 x 480 px)",
    },
    {
      name: "country",
      value: "Country where business operates",
    },
    {
      name: "servicesOfferCounties",
      value: "Countries where you offer your services",
    },
    {
      name: "establishYear",
      value: "Year your Business was established",
    },
    {
      name: "motorcycleModels",
      value:
        "Which RE motorcycles model do you have within your fleet? (Multiple)",
    },
    {
      name: "offerMotorcycle",
      value: "Do you offer motorcycle rental for non-guided tours?",
    },
    {
      name: "guidedTours",
      value: "Guided tours offered",
    },
    {
      name: "selfRental",
      value: "Self rentals options",
    },
    {
      name: "region",
      value: "Region",
    },
    {
      name: "images",
      value: "Gallery Common",
    },
    {
      name: "thumbnailVideo",
      value: "Thumbnail - Partner Detail - Video Poster Image - (1920 x600 px)",
    },
    {
      name: "video",
      value: "Video",
    },
  ];

  const fields = (value) => {
    const data = FieldName.map((item) => {
      if (item.name === value) {
        return item.value;
      }
    });
    return data;
  };

  useEffect(() => {
    dispatch(fetchUpdatedPartnersData(props.partnerId));
  }, []);
  return (
    <>
      {updatedDetails &&
        updatedDetails.changes &&
        updatedDetails.changes[0] !== null &&
        updatedDetails.changes.length > 1 && (
          <div class="col-md-12 d-flex justify-content-between align-items-center">
            <h2 class="title-bar secondary-title font-weight-bold themeColor">
              <span>Partner Detail</span>
            </h2>
            {usertype === "EU Tours Partner" && (
              <p className="statusTxt">Status</p>
            )}
          </div>
        )}
      {updatedDetails &&
        updatedDetails.changes &&
        updatedDetails.changes[0] !== null &&
        updatedDetails.changes.map((item, index) => (
          <Col md={12} className="my-3">
            <div className="d-flex flex-wrap align-items-center justify-content-between">
              <DesignCard
                name={fields(item.field)}
                titleName={
                  item.field === "offerMotorcycle" ||
                  item.field === "selfRental"
                    ? item.value === true
                      ? "Yes"
                      : "No"
                    : item.field === "geo"
                    ? item.value.coordinates.toString()
                    : item.field === "mobile" ||
                      item.field === "secondaryNumber"
                    ? item.value.number
                    : item.field === "social"
                    ? Object.values(item.value).map((item) => {
                        return <div>{item}</div>;
                      })
                    : item.field === "locality"
                    ? item.value.country
                    : item.field === "motorcycleModels" ||
                      item.field === "region" ||
                      item.field === "servicesOfferCounties"
                    ? item.value.toString()
                    : item.field === "rating"
                    ? item.value.region
                    : item.value
                }
              />
              {usertype &&
              (usertype === "EU Tours Admin" || usertype === "Admin") ? (
                <div className="d-flex">
                  <button
                    type="button"
                    className="btn close_btn"
                    onClick={() => {
                      ToggleCollapse();
                      setKey(item.field);
                      setIndexId(item._id);
                    }}
                  >
                    <Icon size={20} icon={ic_close} />
                  </button>
                  <button
                    type="button"
                    className="btn check_btn ml-2"
                    onClick={() => {
                      approveOnClick(item.field);
                      setKey(item.field);
                    }}
                  >
                    <Icon size={20} icon={ic_check} />
                  </button>
                </div>
              ) : (
                <p className={`statusTag ${item.approved.toLowerCase()}`}>
                  {item.approved}
                </p>
              )}
            </div>
            {item.rejectionReason && item.rejectionReason !== "" && (
              <div className="d-flex justify-content-between mt-2">
                <div>
                  <Label className="rejection">Reason of Rejection</Label>
                  <p>{item.rejectionReason}</p>
                </div>
                {usertype && usertype === "EU Tours Partner" && (
                  <CustomButton
                    customType={"button"}
                    name="Delete"
                    customClass={
                      "btn-outline-dark bg-none btnthemeColor partner_p_button"
                    }
                    customClick={() => handleDeleteField(item.field)}
                  />
                )}
              </div>
            )}
            {usertype &&
              (usertype === "EU Tours Admin" || usertype === "Admin") && (
                <div
                  className={`${
                    activeCollapse && indexId == item._id ? "show" : ""
                  } collapse`}
                >
                  <Label className="inputLabel">Reason of Rejection</Label>
                  <div>
                    <FormGroup className="inputWrpper customInputBox">
                      <textarea
                        name="reason"
                        placeholder="Type reason here..."
                        className="inputText mb-0 form-control"
                        rows="4"
                        maxLength={80}
                        onChange={(e) => setRejectionReason(e.target.value)}
                      ></textarea>
                    </FormGroup>
                    <div className="d-flex align-items-center justify-content-between">
                      <CustomButton
                        customType={"button"}
                        name="Cancel"
                        customClass={"btn-outline-dark bg-none btnthemeColor"}
                        customClick={() => ToggleCollapse()}
                      />
                      <CustomButton
                        customType={"button"}
                        name="Submit"
                        customClass={
                          "btn-outline-dark bg-none btnthemeColor ml-3"
                        }
                        customClick={() => rejectionOnSubmit()}
                      />
                    </div>
                  </div>
                  {/* ) : ( */}

                  {/* )} */}
                </div>
              )}
          </Col>
        ))}
      <div>
        {updatedDetails &&
          updatedDetails.gallery &&
          Object.keys(updatedDetails.gallery).length > 0 && (
            <div class="col-md-12 d-flex justify-content-between align-items-center my-3">
              <h2 class="title-bar secondary-title font-weight-bold themeColor">
                <span>Media</span>
              </h2>
              {usertype === "EU Tours Partner" && (
                <p
                  className={`statusTag ${updatedDetails.galleryApproved.toLowerCase()}`}
                >
                  {updatedDetails.galleryApproved}
                </p>
              )}
            </div>
          )}
        {updatedDetails &&
          updatedDetails.gallery &&
          Object.keys(updatedDetails.gallery).map((item) => (
            <Col md={12}>
              <div class="personal_tour_image">{fields(item)}</div>
              <Row>
                {updatedDetails &&
                  updatedDetails.gallery &&
                  updatedDetails.gallery[item] &&
                  updatedDetails.gallery[item].images &&
                  updatedDetails.gallery[item].images.map((data) =>
                    ["JPG", "JPEG", "PNG", "JFIF"].includes(
                      data.srcPath &&
                        data.srcPath.match(/\w+$/)[0].toUpperCase()
                    ) ? (
                      <Col md={3}>
                        <img
                          class="image_tour2"
                          src={`${config.imageBaseUrl}/${data.srcPath}`}
                          alt="img"
                        />
                      </Col>
                    ) : (
                      <Col
                        md={12}
                        className="d-flex justify-content-between mt-3"
                      >
                        <div className="position-relative partner_listing_page">
                          <video width="100%" height="230px" controls>
                            <source
                              src={`${config.imageBaseUrl}/${data.srcPath}`}
                              type="video/mp4"
                            ></source>
                          </video>
                        </div>
                      </Col>
                    )
                  )}
              </Row>
            </Col>
          ))}
        {updatedDetails &&
          updatedDetails.gallery &&
          Object.keys(updatedDetails.gallery).length > 0 &&
          usertype &&
          (usertype === "EU Tours Admin" || usertype === "Admin") && (
            <Col md={12} className="d-flex justify-content-between mt-3">
              <CustomButton
                customType={"button"}
                name="Reject All"
                customClass={"btn-outline-dark bg-none btnthemeColor"}
                // customClick={handleModalPreview}
                customClick={() =>
                  setRejectionReasonToggle(!rejectionReasonToggle)
                }
              />
              <CustomButton
                customType={"button"}
                name="Accept All"
                customClass={"btn-outline-dark bg-none btnthemeColor"}
                customClick={() => handleAcceptorRejectImage("APPROVED")}
              />
            </Col>
          )}
        {updatedDetails &&
          updatedDetails.galleryrejectionReason &&
          updatedDetails.gallery &&
          Object.keys(updatedDetails.gallery).length > 0 && (
            <div className="d-flex justify-content-between px-2 mt-2">
              <div>
                <Label className="rejection">Reason of Rejection</Label>
                <p>{updatedDetails && updatedDetails.galleryrejectionReason}</p>
              </div>
              {usertype && usertype === "EU Tours Partner" && (
                <CustomButton
                  customType={"button"}
                  name="Delete"
                  customClass={
                    "btn-outline-dark bg-none btnthemeColor partner_p_button"
                  }
                  customClick={() => handleDeleteField("gallery")}
                />
              )}
            </div>
          )}
        <Modal isOpen={rejectionReasonToggle} backdrop={true} centered={true}>
          <ModalHeader
            toggle={() => {
              setRejectionReasonToggle(!rejectionReasonToggle);
              setRejectionReason("");
            }}
          >
            {_.get(
              elements,
              "euToursElement.partnerPersonalInfoElement.rejectionModelLabel",
              "Rejection Reason"
            )}
          </ModalHeader>
          <ModalBody>
            <InputText
              inputType={"textarea"}
              inputName={"rejectionReason"}
              customValue={rejectionReasonImage}
              customOnChange={(e) => setRejectionReasonImage(e.target.value)}
            />
          </ModalBody>
          <ModalFooter>
            <CustomButton
              customType={"submit"}
              name={_.get(
                elements,
                "euToursElement.partnerPersonalInfoElement.rejectElement",
                "Reject"
              )}
              customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
              customClick={() => handleReject()}
            />
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
};

export default UpdateModal;
